module.exports = __webpack_public_path__ + "static/media/galeria-fotos-4.0e4e3c50.png";